import axios from 'axios'
import * as actions from '../constants'

export const loadPosts = () => dispatch=>{
  dispatch({
    type: actions.LOAD_POSTS_REQUEST
  })
  axios.get('/posts').then((response)=>{
    if(!response){
      return
    }
    let data = response.data
    dispatch({
      type: actions.LOAD_POSTS_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_POSTS_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const createPost = (post) => (dispatch, getState)=>{
  if(getState().posts.posts.length === 0){
    dispatch({
      type: actions.CREATE_POST_REQUEST
    })
  }
  axios.post('/posts', post).then(({data})=>{
    dispatch({
      type: actions.CREATE_POST_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    console.error(error)
    dispatch({
      type: actions.CREATE_POST_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const deletePost = (_id) => dispatch=>{
  dispatch({
    type: actions.DELETE_POST_REQUEST,
    payload: _id
  })
  axios.delete('/posts/'+_id).then(()=>{
    dispatch({
      type: actions.DELETE_POST_SUCCESS,
      payload: _id
    })
  }).catch(error=>{
    dispatch({
      type: actions.DELETE_POST_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const createComment = (comment) => dispatch=>{
  dispatch({
    type: actions.CREATE_COMMENT_REQUEST
  })
  axios.post('/comments', comment).then(({data})=>{
    dispatch({
      type: actions.CREATE_COMMENT_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.CREATE_COMMENT_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const interactPost = (_id) => ()=>{
  axios.get('/posts/'+_id+'/interact').then(()=>{
  }).catch(error=>{
    console.error(error)
  })
}



// WEBPACK FOOTER //
// ./src/actions/posts.js